export default __webpack_public_path__ + "static/media/loan-Rings.d4443571.svg";